import {
	type WSEvent,
	type WSStatus,
	wsClient,
} from "@shared/services/ws/wsClient";
import { useEffect, useState } from "react";


export function useWSEvents(
	callback: (evt: WSEvent) => void,
	filter?: string | string[],
) {
	useEffect(() => {
		const types = filter ? (Array.isArray(filter) ? filter : [filter]) : null;
		const unsubscribe = wsClient.on((evt) => {
			if (types && !types.includes(evt.type)) return;
			callback(evt);
		});
		return unsubscribe;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [callback, filter]);
}


export function useWSStatus(): WSStatus {
	const [status, setStatus] = useState<WSStatus>(() => wsClient.getStatus());
	useEffect(() => {
		const unsubscribe = wsClient.onStatus(setStatus);
		return unsubscribe;
	}, []);
	return status;
}
